import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../ViewWriter.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  binarySearchyyczvdessj07 as binarySearch,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
  toList3jhuyej2anx2q as toList,
  toSet2orjxp16sotqu as toSet,
  intersect7qttw6wlmz1n as intersect,
  first28gmhyvs4kf06 as first_0,
  minus2znw4oicpx34e as minus,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtMutableList1beimitadwkna as KtMutableList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  ReactiveState__toString_impl_65vhu1175m9ejx57nas as ReactiveState__toString_impl_65vhu1,
  ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from '../RView.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  coerceAtLeastklytehohcpeq as coerceAtLeast,
  coerceAtMostfyc3emgaderp as coerceAtMost,
  downTo39qhfeycepm1j as downTo,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { isNaNymqb93xtq8w8 as isNaN_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  RawReactive253xb355brtjj as RawReactive,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_getInstanceihdke9ufrn8x as Companion_getInstance_0,
  Size2b01934yxlz5f as Size,
  Companion_getInstance1cv3d7873ycho as Companion_getInstance_1,
} from '../../models/Rect.mjs';
import { afterTimeout2ddqxaabn39mu as afterTimeout } from '../../afterTimeout.mjs';
import {
  get_centerX2in8u6xgwmvfr as get_centerX,
  get_centerY2o32deip08ur4 as get_centerY,
  RecyclerViewPlaceable30p36x6wixz5i as RecyclerViewPlaceable,
} from './RecyclerViewPlaceable.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  Companion_instance2rgq1hlpwff0j as Companion_instance,
  Platform_Web_getInstanceu4ctcncq1n0 as Platform_Web_getInstance,
} from '../../Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../Platform.js.mjs';
import {
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../models/data.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
  Companion_getInstance1350ksylxva5s as Companion_getInstance_2,
} from '../../models/Theme.mjs';
import { applyAlpha3k2fcxahu1lgz as applyAlpha } from '../../models/Paint.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  RecyclerViewDatag1ccuuuhm5zb as RecyclerViewData,
  Empty_instance39ymueej3v1xr as Empty_instance,
} from './RecyclerViewData.mjs';
import {
  RecyclerViewRendererSet341fhovxcnndi as RecyclerViewRendererSet,
  Empty_instance2shmal1dtwu66 as Empty_instance_0,
} from './RecyclerViewRendererSet.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import {
  SpecificElement1fm8kkyg4nw48 as SpecificElement,
  FuzzyIndex1f984se19g5yx as FuzzyIndex,
} from './RecyclerViewAnchor.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../direct/ContainingView.commonHtml.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
} from '../../models/data.commonHtml.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_3 } from '../../ViewWrapper.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../direct/ScrollView.commonHtml.js.mjs';
import { ProgrammaticLayout96iub9zkgjmh as ProgrammaticLayout } from '../direct/ProgrammaticLayout.js.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../direct/modifiers.mjs';
import {
  get_atBottomzb604i67rgu3 as get_atBottom,
  get_atEnd1cw5d2zgug26 as get_atEnd,
} from '../helpers.mjs';
import { AppState_getInstance1lcg5jamx8e1g as AppState_getInstance } from '../../reactive/AppState.js.mjs';
import { get_viewUnits3uus4yl4di64 as get_viewUnits } from '../../models/data.js.mjs';
import { RecyclerViewPlacerVerticalGrid1jojlivaz3vdj as RecyclerViewPlacerVerticalGrid } from './RecyclerViewPlacerVerticalGrid.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Recycler2$MyCell$setup$writer$1Class;
function Recycler2$MyCell$setup$writer$1() {
  if (Recycler2$MyCell$setup$writer$1Class === VOID) {
    class $ extends ViewWriter() {
      constructor(this$0, this$1, $index, $box) {
        if ($box === VOID)
          $box = {};
        $box.adf_1 = this$0;
        $box.bdf_1 = this$1;
        $box.cdf_1 = $index;
        super($box);
      }
      pc() {
        return this.adf_1.ddd_1.pc();
      }
      pba(view) {
        return this.adf_1.ddd_1.pba(view);
      }
      rba(view) {
        this.bdf_1.gdf_1 = view;
        if (this.adf_1.idd_1) {
          this.adf_1.ddd_1.rba(view);
        } else {
          var tmp;
          if (this.adf_1.wdd_1.i1()) {
            tmp = -1;
          } else if (this.cdf_1 > last(this.adf_1.wdd_1).las()) {
            tmp = -1;
          } else if (this.cdf_1 < first(this.adf_1.wdd_1).las()) {
            tmp = 0;
          } else {
            var tmp0 = this.adf_1.wdd_1;
            // Inline function 'kotlin.collections.binarySearchBy' call
            var key = this.cdf_1;
            var toIndex = tmp0.p1();
            tmp = binarySearch(tmp0, 0, toIndex, (it) => {
              var tmp$ret$0 = it.las();
              return compareValues(tmp$ret$0, key);
            });
          }
          var index = tmp;
          if (index === -1) {
            this.adf_1.ddd_1.rba(view);
          } else {
            this.adf_1.ddd_1.qba(index, view);
          }
        }
      }
      ea2() {
        return this.adf_1.ddd_1.ea2();
      }
    }
    initMetadataForClass($);
    Recycler2$MyCell$setup$writer$1Class = $;
  }
  return Recycler2$MyCell$setup$writer$1Class;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(1, DurationUnit_SECONDS_getInstance());
  var tmp = delay(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.tdf_1.hdd_1.eb7(0.0);
  $this.tdf_1.ede_1 = false;
  return Unit_instance;
}
function measure$runPlacer(this$0, usedCells, this$1, activeCells, reuseableCells, data, $inProgress, rendererSet) {
  this$0.ade_1 = this$0.ade_1 + 1 | 0;
  usedCells.v3();
  var overdraw = this$1.vdf_1.rd0(this$1.vdf_1.jd0_1 - this$0.rdd_1, this$1.vdf_1.kd0_1 - this$0.rdd_1, this$1.vdf_1.ld0_1 + this$0.rdd_1, this$1.vdf_1.md0_1 + this$0.rdd_1);
  var previousCells = toList(activeCells);
  var tmp0 = toList(activeCells);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp_0;
      if (!rectOverlaps(element.kdf_1, element.ldf_1, element.mdf_1, element.ndf_1, overdraw.jd0_1, overdraw.kd0_1, overdraw.ld0_1, overdraw.md0_1)) {
        element.bdg().hb7(false);
        activeCells.w3(element);
        if (this$0.idd_1) {
          reuseableCells.v(element);
        } else {
          this$0.ddd_1.sba(element.bdg());
        }
        tmp_0 = true;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$0 = count;
  }
  var instantDismissCount = tmp$ret$0;
  var tmp0_safe_receiver = this$0.add_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.fcv(['OFFSCREEN CELLS DISMISSED: ' + instantDismissCount]);
  }
  if (data.yh().i1())
    return Unit_instance;
  var tmp1_safe_receiver = this$0.add_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.fcv(['RUN PLACER IN ' + this$1.vdf_1.toString() + ', anchor is ' + toString(this$0.sdd_1)]);
  }
  var tmp2_$this = this$0.tdd_1;
  var tmp3_dataRange = data.yh();
  var tmp4_anchor = this$0.sdd_1;
  var tmp5_previousViewport = this$0.sde_1;
  var tmp6_viewport = this$1.vdf_1;
  var tmp7_paddingTop = $inProgress.cdg();
  var tmp8_paddingLeft = $inProgress.ddg();
  var tmp9_paddingRight = $inProgress.edg();
  var tmp10_paddingBottom = $inProgress.fdg();
  var tmp11_gap = $inProgress.gdg();
  tmp2_$this.ldg(tmp3_dataRange, tmp4_anchor, tmp5_previousViewport, previousCells, (index, size) => {
    var tmp;
    var progression = data.yh();
    var containsLower = progression.i2_1;
    var containsUpper = progression.j2_1;
    if (!(containsLower <= index ? index <= containsUpper : false)) {
      throw IllegalStateException().o4("You can't pull a cell not in data range.");
    }
    var item = data.q1(index);
    var renderer = rendererSet.hdg(item);
    var id = rendererSet.idg(item);
    // Inline function 'kotlin.collections.find' call
    var tmp0 = activeCells;
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        var this_0 = element.edf_1.qah();
        var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
        var tmp_0;
        if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
          tmp_0 = false;
        } else {
          if (tmp0_subject instanceof InternalReactiveThrownException()) {
            _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
            tmp_0 = false;
          } else {
            if (tmp0_subject instanceof InternalReactiveWrapper()) {
              var tmp_1 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
              var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
              tmp_0 = equals(rendererSet.idg(it), id);
            } else {
              var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
              tmp_0 = equals(rendererSet.idg(it_0), id);
            }
          }
        }
        if (tmp_0) {
          tmp$ret$8 = element;
          break $l$block_0;
        }
      }
      tmp$ret$8 = null;
    }
    var tmp0_safe_receiver = tmp$ret$8;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      tmp0_safe_receiver.jdg(size, _ReactiveState___init__impl__fvdp9b(item), index, $inProgress);
      tmp_2 = tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp_2;
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.takeIf' call
      var this_1 = reuseableCells;
      var tmp_4;
      if (this$0.idd_1) {
        tmp_4 = this_1;
      } else {
        tmp_4 = null;
      }
      var tmp2_safe_receiver = tmp_4;
      var tmp_5;
      if (tmp2_safe_receiver == null) {
        tmp_5 = null;
      } else {
        tmp_5 = popOrNull(tmp2_safe_receiver, (it) => equals(it.f94(), renderer));
      }
      var tmp3_safe_receiver = tmp_5;
      var tmp_6;
      if (tmp3_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
        var tmp_7 = tmp3_safe_receiver.bdg().tb5_1.vb3_1;
        var tmp0_safe_receiver_0 = tmp_7 instanceof HTMLElement ? tmp_7 : null;
        var tmp_8;
        if (tmp0_safe_receiver_0 == null) {
          tmp_8 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
          var this_2 = tmp0_safe_receiver_0;
          var animate = get_animationsEnabled();
          try {
            if (animate) {
              set_animationsEnabled(false);
              // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
              // Inline function 'kotlin.js.asDynamic' call
              var tmp_9 = this_2.__suppressMutationObserverClass;
              var tmp0_elvis_lhs = tmp_9 instanceof ArrayList() ? tmp_9 : null;
              var tmp_10;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.run' call
                var n = ArrayList().w();
                // Inline function 'kotlin.js.asDynamic' call
                this_2.__suppressMutationObserverClass = n;
                tmp_10 = n;
              } else {
                tmp_10 = tmp0_elvis_lhs;
              }
              var e = tmp_10;
              this_2.classList.add('notransition');
              var tmp1_elvis_lhs_0 = this_2.getAttribute('class');
              e.v(tmp1_elvis_lhs_0 == null ? '' : tmp1_elvis_lhs_0);
            }
            tmp3_safe_receiver.jdg(size, _ReactiveState___init__impl__fvdp9b(item), index, $inProgress);
          }finally {
            if (animate) {
              var tmp_11 = window;
              tmp_11.setTimeout(() => {
                // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                var this_0 = this_2;
                // Inline function 'kotlin.js.asDynamic' call
                var tmp = this_0.__suppressMutationObserverClass;
                var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
                var tmp_0;
                if (tmp0_elvis_lhs == null) {
                  // Inline function 'kotlin.run' call
                  var n = ArrayList().w();
                  // Inline function 'kotlin.js.asDynamic' call
                  this_0.__suppressMutationObserverClass = n;
                  tmp_0 = n;
                } else {
                  tmp_0 = tmp0_elvis_lhs;
                }
                var e = tmp_0;
                this_2.classList.remove('notransition');
                var tmp1_elvis_lhs = this_0.getAttribute('class');
                e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                return Unit_instance;
              }, 100);
              set_animationsEnabled(true);
            }
          }
          tmp_8 = Unit_instance;
        }
        if (tmp_8 == null) {
          tmp3_safe_receiver.jdg(size, _ReactiveState___init__impl__fvdp9b(item), index, $inProgress);
        }
        // Inline function 'kotlin.collections.plusAssign' call
        activeCells.v(tmp3_safe_receiver);
        tmp_6 = tmp3_safe_receiver;
      }
      tmp_3 = tmp_6;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var tmp4_elvis_lhs = tmp_3;
    var tmp_12;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_3 = new (MyCell())(this$0);
      // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
      var tmp_13 = this$0.ddd_1.tb5_1.vb3_1;
      var tmp0_safe_receiver_1 = tmp_13 instanceof HTMLElement ? tmp_13 : null;
      var tmp_14;
      if (tmp0_safe_receiver_1 == null) {
        tmp_14 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
        var this_4 = tmp0_safe_receiver_1;
        var animate_0 = get_animationsEnabled();
        try {
          if (animate_0) {
            set_animationsEnabled(false);
            // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp_15 = this_4.__suppressMutationObserverClass;
            var tmp0_elvis_lhs_0 = tmp_15 instanceof ArrayList() ? tmp_15 : null;
            var tmp_16;
            if (tmp0_elvis_lhs_0 == null) {
              // Inline function 'kotlin.run' call
              var n_0 = ArrayList().w();
              // Inline function 'kotlin.js.asDynamic' call
              this_4.__suppressMutationObserverClass = n_0;
              tmp_16 = n_0;
            } else {
              tmp_16 = tmp0_elvis_lhs_0;
            }
            var e_0 = tmp_16;
            this_4.classList.add('notransition');
            var tmp1_elvis_lhs_1 = this_4.getAttribute('class');
            e_0.v(tmp1_elvis_lhs_1 == null ? '' : tmp1_elvis_lhs_1);
          }
          this_3.kdg(rendererSet.hdg(item), size, _ReactiveState___init__impl__fvdp9b(item), index, $inProgress);
        }finally {
          if (animate_0) {
            var tmp_17 = window;
            tmp_17.setTimeout(() => {
              // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
              var this_0 = this_4;
              // Inline function 'kotlin.js.asDynamic' call
              var tmp = this_0.__suppressMutationObserverClass;
              var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.run' call
                var n = ArrayList().w();
                // Inline function 'kotlin.js.asDynamic' call
                this_0.__suppressMutationObserverClass = n;
                tmp_0 = n;
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              var e = tmp_0;
              this_4.classList.remove('notransition');
              var tmp1_elvis_lhs = this_0.getAttribute('class');
              e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
              return Unit_instance;
            }, 100);
            set_animationsEnabled(true);
          }
        }
        tmp_14 = Unit_instance;
      }
      if (tmp_14 == null) {
        this_3.kdg(rendererSet.hdg(item), size, _ReactiveState___init__impl__fvdp9b(item), index, $inProgress);
      }
      // Inline function 'kotlin.collections.plusAssign' call
      activeCells.v(this_3);
      tmp_12 = this_3;
    } else {
      tmp_12 = tmp4_elvis_lhs;
    }
    // Inline function 'kotlin.also' call
    var this_5 = tmp_12;
    // Inline function 'kotlin.collections.plusAssign' call
    usedCells.v(this_5);
    return this_5;
  }, tmp6_viewport, overdraw, tmp7_paddingTop, tmp8_paddingLeft, tmp9_paddingRight, tmp10_paddingBottom, tmp11_gap);
  this$0.sde_1 = this$1.vdf_1;
  this$0.sdd_1 = null;
}
function measure$requestOffset(this$0, this$1, activeCells, x, y) {
  this$0.zdf_1 = true;
  var tmp0_safe_receiver = this$1.add_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.fcv(['OFFSET: ' + x + ' / ' + y]);
  }
  var vx = coerceAtLeast(x, -this$0.vdf_1.jd0_1);
  var vy = coerceAtLeast(y, -this$0.vdf_1.kd0_1);
  var tmp1_safe_receiver = this$1.add_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.fcv(['OFFSET2: ' + vx + ' / ' + vy]);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = activeCells.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    element.mdg(x, y);
  }
  this$1.sde_1 = this$1.sde_1.rd0(this$1.sde_1.jd0_1 + vx, this$1.sde_1.kd0_1 + vy, this$1.sde_1.ld0_1 + vx, this$1.sde_1.md0_1 + vy);
  this$0.vdf_1 = this$0.vdf_1.rd0(this$0.vdf_1.jd0_1 + vx, this$0.vdf_1.kd0_1 + vy, this$0.vdf_1.ld0_1 + vx, this$0.vdf_1.md0_1 + vy);
  this$0.udf_1 = to(this$0.vdf_1.jd0_1, this$0.vdf_1.kd0_1);
  this$0.xdf_1 = coerceAtMost(this$0.xdf_1 + (this$1.zdc_1 ? vy : vx), this$1.ydd_1);
}
function layout$commitPosition(this$0, $inProgress, it) {
  if (!(roundToInt(it.kdf_1) === roundToInt(it.odf_1)) || !(roundToInt(it.ldf_1) === roundToInt(it.pdf_1)) || !(roundToInt(it.mdf_1) === roundToInt(it.qdf_1)) || !(roundToInt(it.ndf_1) === roundToInt(it.rdf_1))) {
    var tmp0_safe_receiver = this$0.add_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fcv(['CHANGING POSITION FOR ' + it.las() + ' from (' + it.odf_1 + ', ' + it.pdf_1 + ') to (' + it.kdf_1 + ', ' + it.ldf_1 + ')']);
    }
    this$0.cde_1 = this$0.cde_1 + 1 | 0;
    $inProgress.jdb(it.bdg(), it.kdf_1, it.ldf_1, it.mdf_1, it.ndf_1);
    it.odf_1 = it.kdf_1;
    it.pdf_1 = it.ldf_1;
    it.qdf_1 = it.mdf_1;
    it.rdf_1 = it.ndf_1;
  }
}
function layout$_anonymous_$visibleRatio_9lqaa2(_this__u8e3s4, viewport) {
  var tmp0 = _this__u8e3s4.mdf_1;
  // Inline function 'kotlin.math.min' call
  var b = viewport.ld0_1;
  var tmp = Math.min(tmp0, b);
  var tmp0_0 = _this__u8e3s4.kdf_1;
  // Inline function 'kotlin.math.max' call
  var b_0 = viewport.jd0_1;
  var h = (tmp - Math.max(tmp0_0, b_0)) / (_this__u8e3s4.mdf_1 - _this__u8e3s4.kdf_1);
  var tmp0_1 = _this__u8e3s4.ndf_1;
  // Inline function 'kotlin.math.min' call
  var b_1 = viewport.md0_1;
  var tmp_0 = Math.min(tmp0_1, b_1);
  var tmp0_2 = _this__u8e3s4.ldf_1;
  // Inline function 'kotlin.math.max' call
  var b_2 = viewport.kd0_1;
  var v = (tmp_0 - Math.max(tmp0_2, b_2)) / (_this__u8e3s4.ndf_1 - _this__u8e3s4.ldf_1);
  // Inline function 'kotlin.takeIf' call
  var this_0 = h * v;
  var tmp_1;
  if (!isNaN_0(this_0) && this_0 >= 0.0) {
    tmp_1 = this_0;
  } else {
    tmp_1 = null;
  }
  var tmp0_elvis_lhs = tmp_1;
  return tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
}
var MyCellClass;
function MyCell() {
  if (MyCellClass === VOID) {
    class $ {
      constructor($outer) {
        this.sdf_1 = $outer;
        this.ddf_1 = Signal().fak(-1);
        this.edf_1 = RawReactive().yah();
        this.hdf_1 = Companion_getInstance_0().sd0_1;
        this.idf_1 = null;
        this.jdf_1 = null;
        this.kdf_1 = 0.0;
        this.ldf_1 = 0.0;
        this.mdf_1 = 0.0;
        this.ndf_1 = 0.0;
        this.odf_1 = 0.0;
        this.pdf_1 = 0.0;
        this.qdf_1 = 0.0;
        this.rdf_1 = 0.0;
      }
      f94() {
        var tmp = this.fdf_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('type');
        }
      }
      bdg() {
        var tmp = this.gdf_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('view');
        }
      }
      kdg(type, constrain, data, index, inProgress) {
        this.fdf_1 = type;
        this.edf_1.pah(data);
        this.ddf_1.mam(index);
        var tmp0_safe_receiver = this.sdf_1.add_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['CELL CREATED: from ' + ReactiveState__toString_impl_65vhu1(data) + ' at ' + index]);
        }
        var writer = new (Recycler2$MyCell$setup$writer$1())(this.sdf_1, this, index);
        type.ndg(writer, this.edf_1, this.ddf_1);
        this.hdf_1 = constrain;
        this.jdf_1 = null;
        this.idf_1 = inProgress;
      }
      jdg(constrain, data, index, inProgress) {
        this.bdg().hb7(true);
        this.bdg().eb7(1.0);
        this.edf_1.pah(data);
        this.ddf_1.mam(index);
        this.hdf_1 = constrain;
        this.jdf_1 = null;
        this.idf_1 = inProgress;
      }
      odg() {
        this.bdg().eb7(0.0);
        var reuse = this.sdf_1.xdd_1;
        this.sdf_1.wdd_1.w3(this);
        var tmp = _Duration___get_inWholeMilliseconds__impl__msfiry(this.bdg().kba().tb0_1);
        afterTimeout(this.sdf_1, tmp, () => {
          this.bdg().hb7(false);
          if (this.sdf_1.idd_1) {
            reuse.v(this);
          } else {
            this.sdf_1.ddd_1.sba(this.bdg());
          }
          return Unit_instance;
        });
      }
      pdg() {
        this.bdg().hb7(false);
        this.sdf_1.wdd_1.w3(this);
        if (this.sdf_1.idd_1) {
          this.sdf_1.xdd_1.v(this);
        } else {
          this.sdf_1.ddd_1.sba(this.bdg());
        }
      }
      las() {
        return this.ddf_1.f2();
      }
      p1() {
        var tmp0_elvis_lhs = this.jdf_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var _unary__edvuaz = this.sdf_1.bde_1;
          this.sdf_1.bde_1 = _unary__edvuaz + 1 | 0;
          var n = ensureNotNull(this.idf_1).qdg(this.bdg(), this.hdf_1);
          this.jdf_1 = n;
          tmp = n;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      rdg() {
        return this.kdf_1;
      }
      sdg() {
        return this.ldf_1;
      }
      tdg() {
        return this.mdf_1;
      }
      udg() {
        return this.ndf_1;
      }
      vdg(left, top, right, bottom) {
        this.kdf_1 = left;
        this.ldf_1 = top;
        this.mdf_1 = right;
        this.ndf_1 = bottom;
      }
      mdg(x, y) {
        this.kdf_1 = this.kdf_1 + x;
        this.mdf_1 = this.mdf_1 + x;
        this.ldf_1 = this.ldf_1 + y;
        this.ndf_1 = this.ndf_1 + y;
      }
    }
    protoOf($).pd0 = get_centerX;
    protoOf($).qd0 = get_centerY;
    initMetadataForClass($, 'MyCell', VOID, VOID, [RecyclerViewPlaceable()]);
    MyCellClass = $;
  }
  return MyCellClass;
}
function _get_statsCellCount__kp2e3h($this) {
  return $this.ddd_1.oba().p1();
}
function setFakeScrollByRatio($this, start, end) {
  var tmp0_safe_receiver = $this.add_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.fcv(['setFakeScrollByRatio ' + start + ' - ' + end]);
  }
  if (get_current(Companion_instance).equals(Platform_Web_getInstance())) {
    var tmp1_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp($this.wdg().xdg().qah());
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var vp = tmp;
    var vps = $this.zdc_1 ? vp.od0() : vp.nd0();
    $this.kde_1 = vps / (end - start);
    $this.lde_1 = start * $this.kde_1;
    var tmp2_safe_receiver = $this.add_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.fcv(['fakeScrollSize: ' + $this.kde_1]);
    }
    var tmp3_safe_receiver = $this.add_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.fcv(['vps: ' + vps]);
    }
    var tmp4_safe_receiver = $this.add_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.fcv(['end: ' + end]);
    }
    var tmp5_safe_receiver = $this.add_1;
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.fcv(['start: ' + start]);
    }
    var tmp6_safe_receiver = $this.add_1;
    if (tmp6_safe_receiver == null)
      null;
    else {
      tmp6_safe_receiver.fcv(['fakeScrollOffset: ' + $this.lde_1]);
    }
    var tmp7_safe_receiver = $this.add_1;
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.fcv(['setFakeScrollByRatio calls invalidateLayout() on fake']);
    }
    $this.gdd_1.ddj();
  } else {
    var tmp8_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp($this.wdg().xdg().qah());
    var tmp_0;
    if (tmp8_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp8_elvis_lhs;
    }
    var vp_0 = tmp_0;
    var vps_0 = $this.zdc_1 ? vp_0.od0() : vp_0.nd0();
    $this.kde_1 = vps_0 - 1.0;
    $this.fde_1 = start;
    $this.gde_1 = end;
    if (end - start < 0.99) {
      if (!$this.ede_1) {
        $this.hdd_1.eb7(1.0);
        $this.ede_1 = true;
      }
      var tmp9_safe_receiver = $this.dde_1;
      if (tmp9_safe_receiver == null)
        null;
      else {
        tmp9_safe_receiver.ma3();
      }
      var tmp_1 = $this;
      tmp_1.dde_1 = launch($this.hdd_1, VOID, VOID, Recycler2$setFakeScrollByRatio$slambda_0($this));
    } else if ($this.ede_1) {
      $this.hdd_1.eb7(0.0);
    }
    var tmp10_safe_receiver = $this.add_1;
    if (tmp10_safe_receiver == null)
      null;
    else {
      tmp10_safe_receiver.fcv(['setFakeScrollByRatio calls invalidateLayout() on fake']);
    }
    $this.gdd_1.ddj();
  }
}
var Recycler2$firstIndex$slambdaClass;
function Recycler2$firstIndex$slambda() {
  if (Recycler2$firstIndex$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.edj_1 = this$0;
      }
      fdj($this$withWrite, it, $completion) {
        if (!(it === this.edj_1.kdd_1.f2())) {
          this.edj_1.gdj(it, Align_Start_getInstance());
        }
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.fdj(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    Recycler2$firstIndex$slambdaClass = $;
  }
  return Recycler2$firstIndex$slambdaClass;
}
function Recycler2$firstIndex$slambda_0(this$0) {
  var i = new (Recycler2$firstIndex$slambda())(this$0);
  var l = ($this$withWrite, it, $completion) => i.fdj($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
var Recycler2$lastIndex$slambdaClass;
function Recycler2$lastIndex$slambda() {
  if (Recycler2$lastIndex$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.hdj_1 = this$0;
      }
      fdj($this$withWrite, it, $completion) {
        if (!(it === this.hdj_1.mdd_1.f2())) {
          this.hdj_1.gdj(it, Align_End_getInstance());
        }
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.fdj(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    Recycler2$lastIndex$slambdaClass = $;
  }
  return Recycler2$lastIndex$slambdaClass;
}
function Recycler2$lastIndex$slambda_0(this$0) {
  var i = new (Recycler2$lastIndex$slambda())(this$0);
  var l = ($this$withWrite, it, $completion) => i.fdj($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
var Recycler2$centerIndex$slambdaClass;
function Recycler2$centerIndex$slambda() {
  if (Recycler2$centerIndex$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.idj_1 = this$0;
      }
      fdj($this$withWrite, it, $completion) {
        if (!(it === this.idj_1.jdd_1.f2())) {
          this.idj_1.gdj(it, Align_Center_getInstance());
        }
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.fdj(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    Recycler2$centerIndex$slambdaClass = $;
  }
  return Recycler2$centerIndex$slambdaClass;
}
function Recycler2$centerIndex$slambda_0(this$0) {
  var i = new (Recycler2$centerIndex$slambda())(this$0);
  var l = ($this$withWrite, it, $completion) => i.fdj($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
var Recycler2$$inlined$with$1Class;
function Recycler2$$inlined$with$1() {
  if (Recycler2$$inlined$with$1Class === VOID) {
    class $ {
      constructor($$this$frame) {
        this.jdj_1 = $$this$frame;
      }
      fd1(theme) {
        return this.jdj_1.pb6_1.fb1_1 ? theme.yb0_1 : theme.ab1_1;
      }
    }
    protoOf($).ybe = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    Recycler2$$inlined$with$1Class = $;
  }
  return Recycler2$$inlined$with$1Class;
}
var Recycler2$$inlined$with$2Class;
function Recycler2$$inlined$with$2() {
  if (Recycler2$$inlined$with$2Class === VOID) {
    class $ {
      fd1(theme) {
        return theme.ud1('scrollindicator', VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, applyAlpha(theme.jb0_1, 0.5)).yb0_1;
      }
    }
    protoOf($).ybe = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    Recycler2$$inlined$with$2Class = $;
  }
  return Recycler2$$inlined$with$2Class;
}
var Recycler2$setFakeScrollByRatio$slambdaClass;
function Recycler2$setFakeScrollByRatio$slambda() {
  if (Recycler2$setFakeScrollByRatio$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.tdf_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Recycler2$setFakeScrollByRatio$slambdaClass = $;
  }
  return Recycler2$setFakeScrollByRatio$slambdaClass;
}
function Recycler2$setFakeScrollByRatio$slambda_0(this$0) {
  var i = new (Recycler2$setFakeScrollByRatio$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var Recycler2$fakeScrollLayoutDelegate$1Class;
function Recycler2$fakeScrollLayoutDelegate$1() {
  if (Recycler2$fakeScrollLayoutDelegate$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.kdj_1 = this$0;
      }
      hdb(layout, inProgress, within) {
        return this.kdj_1.zdc_1 ? new (Size())(within.td0_1, this.kdj_1.kde_1) : new (Size())(this.kdj_1.kde_1, within.ud0_1);
      }
      idb(layout, inProgress, within) {
        if (get_current(Companion_instance).equals(Platform_Web_getInstance())) {
          var tmp0_safe_receiver = this.kdj_1.add_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.fcv(['']);
          }
          this.kdj_1.jde_1 = true;
          var tmp0 = within.td0_1;
          // Inline function 'kotlin.math.min' call
          var b = within.ud0_1;
          var s = Math.min(tmp0, b);
          if (this.kdj_1.zdc_1) {
            inProgress.jdb(this.kdj_1.hdd_1, 0.0, this.kdj_1.kde_1 - 1, 1.0, this.kdj_1.kde_1);
          } else {
            inProgress.jdb(this.kdj_1.hdd_1, this.kdj_1.kde_1 - 1, 0.0, this.kdj_1.kde_1, 1.0);
          }
          this.kdj_1.wdg().ldj(this.kdj_1.zdc_1 ? 0.0 : this.kdj_1.lde_1, this.kdj_1.zdc_1 ? this.kdj_1.lde_1 : 0.0, false);
        } else {
          if (this.kdj_1.zdc_1) {
            var size = coerceAtLeast((this.kdj_1.gde_1 - this.kdj_1.fde_1) * within.ud0_1, within.td0_1 * 2) / 2;
            var center = (this.kdj_1.gde_1 + this.kdj_1.fde_1) / 2 * within.ud0_1;
            inProgress.jdb(this.kdj_1.hdd_1, within.td0_1 * 0.6, center - size, within.td0_1 * 0.8, center + size);
          } else {
            var size_0 = coerceAtLeast((this.kdj_1.gde_1 - this.kdj_1.fde_1) * within.td0_1, within.ud0_1 * 2) / 2;
            var center_0 = (this.kdj_1.gde_1 + this.kdj_1.fde_1) / 2 * within.td0_1;
            var tmp1_child = this.kdj_1.hdd_1;
            var tmp2_top = within.ud0_1 * 0.6;
            var tmp3_left = center_0 - size_0;
            var tmp4_bottom = within.ud0_1 * 0.8;
            var tmp5_right = center_0 + size_0;
            inProgress.jdb(tmp1_child, tmp3_left, tmp2_top, tmp5_right, tmp4_bottom);
          }
        }
      }
    }
    initMetadataForClass($);
    Recycler2$fakeScrollLayoutDelegate$1Class = $;
  }
  return Recycler2$fakeScrollLayoutDelegate$1Class;
}
function Recycler2$lambda() {
  return Unit_instance;
}
var Recycler2$programmaticLayoutDelegate$1Class;
function Recycler2$programmaticLayoutDelegate$1() {
  if (Recycler2$programmaticLayoutDelegate$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.adg_1 = this$0;
        this.udf_1 = null;
        this.vdf_1 = Companion_getInstance_1().hd0_1;
        this.wdf_1 = null;
        this.xdf_1 = this$0.ydd_1;
        this.ydf_1 = false;
        this.zdf_1 = false;
      }
      hdb(layout, inProgress, within) {
        this.adg_1.mde_1 = inProgress.cdg();
        this.adg_1.nde_1 = inProgress.ddg();
        this.adg_1.ode_1 = inProgress.edg();
        this.adg_1.pde_1 = inProgress.fdg();
        if (this.ydf_1)
          return ensureNotNull(this.wdf_1);
        var default_0 = within;
        if (within.equals(Companion_getInstance_0().sd0_1)) {
          var tmp0_safe_receiver = this.adg_1.add_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.fcv(['measure stop: if (within == Size.Zero) {']);
          }
          return default_0;
        }
        if (!this.zdf_1) {
          var tmp = this;
          var tmp1_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(this.adg_1.mdj().xdg().qah());
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var tmp0_safe_receiver_0 = this.adg_1.add_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.fcv(['measure stop: viewport = scroll.viewport.state.getOrNull() ?: run {']);
            }
            return default_0;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          tmp.vdf_1 = tmp_0;
        }
        var tmp2_safe_receiver = this.adg_1.add_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.fcv(['measure: Loaded viewport, found ' + this.vdf_1.toString()]);
        }
        if (this.vdf_1.nd0() === 0.0 || this.vdf_1.od0() === 0.0) {
          var tmp3_safe_receiver = this.adg_1.add_1;
          if (tmp3_safe_receiver == null)
            null;
          else {
            tmp3_safe_receiver.fcv(['measure stop: if (viewport.width == 0.0 || viewport.height == 0.0) {']);
          }
          return default_0;
        }
        var tmp4_safe_receiver = this.adg_1.add_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.fcv(['LAYOUT STARTING with size ' + within.toString()]);
        }
        var tmp_1 = this.adg_1.udd_1;
        var tmp5_elvis_lhs = (!(tmp_1 == null) ? isInterface(tmp_1, RecyclerViewData()) : false) ? tmp_1 : null;
        var tmp_2;
        if (tmp5_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_1 = this.adg_1.add_1;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.fcv(['measure stop: val data = data as? RecyclerViewData<Any, Any> ?: run {']);
          }
          return default_0;
        } else {
          tmp_2 = tmp5_elvis_lhs;
        }
        var data = tmp_2;
        var tmp_3 = this.adg_1.vdd_1;
        var tmp6_elvis_lhs = (!(tmp_3 == null) ? isInterface(tmp_3, RecyclerViewRendererSet()) : false) ? tmp_3 : null;
        var tmp_4;
        if (tmp6_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_2 = this.adg_1.add_1;
          if (tmp0_safe_receiver_2 == null)
            null;
          else {
            tmp0_safe_receiver_2.fcv(['measure stop: val rendererSet = rendererSet as? RecyclerViewRendererSet<Any, Any> ?: run {']);
          }
          return default_0;
        } else {
          tmp_4 = tmp6_elvis_lhs;
        }
        var rendererSet = tmp_4;
        var tmp_5 = this.adg_1.wdd_1;
        var tmp7_elvis_lhs = isInterface(tmp_5, KtMutableList()) ? tmp_5 : null;
        var tmp_6;
        if (tmp7_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_3 = this.adg_1.add_1;
          if (tmp0_safe_receiver_3 == null)
            null;
          else {
            tmp0_safe_receiver_3.fcv(['measure stop: val activeCells = activeCells as? MutableList<MyCell<Any>> ?: run {']);
          }
          return default_0;
        } else {
          tmp_6 = tmp7_elvis_lhs;
        }
        var activeCells = tmp_6;
        var tmp_7 = this.adg_1.xdd_1;
        var tmp8_elvis_lhs = isInterface(tmp_7, KtMutableList()) ? tmp_7 : null;
        var tmp_8;
        if (tmp8_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_4 = this.adg_1.add_1;
          if (tmp0_safe_receiver_4 == null)
            null;
          else {
            tmp0_safe_receiver_4.fcv(['measure stop: val reuseableCells = reuseableCells as? MutableList<MyCell<Any>> ?: run {']);
          }
          return default_0;
        } else {
          tmp_8 = tmp8_elvis_lhs;
        }
        var reuseableCells = tmp_8;
        var tmp9_safe_receiver = this.adg_1.add_1;
        if (tmp9_safe_receiver == null)
          null;
        else {
          tmp9_safe_receiver.fcv(['LAYOUT STARTED IN VIEWPORT ' + this.vdf_1.toString() + ', isMoving: ' + this.adg_1.rde_1.f2()]);
        }
        var usedCells = HashSet().ha();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = intersect(toSet(activeCells), toSet(reuseableCells)).m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver_5 = this.adg_1.add_1;
          if (tmp0_safe_receiver_5 == null)
            null;
          else {
            tmp0_safe_receiver_5.fcv(['WARNING!!! Active and reusable cell ' + toString_0(element)]);
          }
        }
        measure$runPlacer(this.adg_1, usedCells, this, activeCells, reuseableCells, data, inProgress, rendererSet);
        var firstCell = null;
        var lastCell = null;
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = usedCells.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          if (element_0.las() === data.yh().i2_1)
            firstCell = element_0;
          if (element_0.las() === data.yh().j2_1)
            lastCell = element_0;
        }
        var tmp10_safe_receiver = this.adg_1.add_1;
        if (tmp10_safe_receiver == null)
          null;
        else {
          tmp10_safe_receiver.fcv(['ATTACHMENT: ' + toString(firstCell) + ' / ' + toString(lastCell)]);
        }
        var tmp_9 = this;
        var tmp_10;
        if (!(lastCell == null)) {
          // Inline function 'kotlin.also' call
          var this_0 = this.adg_1.zdc_1 ? lastCell.ndf_1 + inProgress.fdg() : lastCell.mdf_1 + inProgress.edg();
          if (this.vdf_1.md0_1 > this_0) {
            this.adg_1.ide_1 = true;
            this.adg_1.jde_1 = true;
          }
          tmp_10 = this_0;
        } else {
          tmp_10 = this.adg_1.ydd_1;
        }
        tmp_9.xdf_1 = tmp_10;
        var tmp11_safe_receiver = this.adg_1.add_1;
        if (tmp11_safe_receiver == null)
          null;
        else {
          tmp11_safe_receiver.fcv(['SENTINEL SIZE: ' + this.xdf_1]);
        }
        var atScrollEdge = (this.adg_1.zdc_1 ? this.vdf_1.kd0_1 : this.vdf_1.jd0_1) < 1 || (this.adg_1.zdc_1 ? this.vdf_1.md0_1 : this.vdf_1.ld0_1) > this.adg_1.ydd_1 - 1;
        if (!(firstCell == null)) {
          if (this.adg_1.zdc_1) {
            // Inline function 'kotlin.math.abs' call
            var x = inProgress.cdg() - firstCell.ldf_1;
            if (Math.abs(x) > 1.0) {
              var tmp12_safe_receiver = this.adg_1.add_1;
              if (tmp12_safe_receiver == null)
                null;
              else {
                tmp12_safe_receiver.fcv(['WILL OFFSET AT ' + this.vdf_1.toString()]);
              }
              if (this.vdf_1.kd0_1 < firstCell.ldf_1 - inProgress.cdg() + 0.1) {
                var tmp13_safe_receiver = this.adg_1.add_1;
                if (tmp13_safe_receiver == null)
                  null;
                else {
                  tmp13_safe_receiver.fcv(['JERK REQUIRED: ' + this.vdf_1.kd0_1 + ' < ' + firstCell.ldf_1 + ' - ' + inProgress.cdg()]);
                }
                measure$requestOffset(this, this.adg_1, activeCells, 0.0, -firstCell.ldf_1 + inProgress.cdg());
                this.adg_1.sdd_1 = new (SpecificElement())(data.yh().i2_1, Align_Start_getInstance());
                var tmp14_safe_receiver = this.adg_1.add_1;
                if (tmp14_safe_receiver == null)
                  null;
                else {
                  tmp14_safe_receiver.fcv(['anchor = ' + toString(this.adg_1.sdd_1) + ' (Offset follow up)']);
                }
                measure$runPlacer(this.adg_1, usedCells, this, activeCells, reuseableCells, data, inProgress, rendererSet);
              } else if (!this.adg_1.rde_1.f2()) {
                var tmp15_safe_receiver = this.adg_1.add_1;
                if (tmp15_safe_receiver == null)
                  null;
                else {
                  tmp15_safe_receiver.fcv(['SHIFTING CELLS TO ATTACH TO TOP: ' + firstCell.ldf_1 + ' -> ' + inProgress.cdg()]);
                }
                measure$requestOffset(this, this.adg_1, activeCells, 0.0, -firstCell.ldf_1 + inProgress.cdg());
              }
            }
          } else {
            // Inline function 'kotlin.math.abs' call
            var x_0 = inProgress.ddg() - firstCell.kdf_1;
            if (Math.abs(x_0) > 1.0) {
              var tmp16_safe_receiver = this.adg_1.add_1;
              if (tmp16_safe_receiver == null)
                null;
              else {
                tmp16_safe_receiver.fcv(['WILL OFFSET AT ' + this.vdf_1.toString()]);
              }
              if (this.vdf_1.jd0_1 < firstCell.kdf_1 - inProgress.ddg() + 0.1) {
                var tmp17_safe_receiver = this.adg_1.add_1;
                if (tmp17_safe_receiver == null)
                  null;
                else {
                  tmp17_safe_receiver.fcv(['JERK REQUIRED: ' + this.vdf_1.jd0_1 + ' < ' + firstCell.kdf_1 + ' - ' + inProgress.ddg()]);
                }
                measure$requestOffset(this, this.adg_1, activeCells, -firstCell.kdf_1 + inProgress.ddg(), 0.0);
                this.adg_1.sdd_1 = new (SpecificElement())(data.yh().i2_1, Align_Start_getInstance());
                var tmp18_safe_receiver = this.adg_1.add_1;
                if (tmp18_safe_receiver == null)
                  null;
                else {
                  tmp18_safe_receiver.fcv(['anchor = ' + toString(this.adg_1.sdd_1) + ' (Offset follow up)']);
                }
                measure$runPlacer(this.adg_1, usedCells, this, activeCells, reuseableCells, data, inProgress, rendererSet);
              } else if (!this.adg_1.rde_1.f2()) {
                var tmp19_safe_receiver = this.adg_1.add_1;
                if (tmp19_safe_receiver == null)
                  null;
                else {
                  tmp19_safe_receiver.fcv(['SHIFTING CELLS TO ATTACH TO TOP: ' + firstCell.kdf_1 + ' -> ' + inProgress.ddg()]);
                }
                measure$requestOffset(this, this.adg_1, activeCells, -firstCell.kdf_1 + inProgress.ddg(), 0.0);
              }
            }
          }
        } else {
          var tmp_11;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!usedCells.i1()) {
            tmp_11 = !this.adg_1.rde_1.f2() || atScrollEdge;
          } else {
            tmp_11 = false;
          }
          if (tmp_11) {
            var sampleCell = first_0(usedCells);
            var tmp_12;
            if (this.adg_1.zdc_1) {
              var containsLower = this.adg_1.ydd_1 * 1 / 4;
              var containsUpper = this.adg_1.ydd_1 * 3 / 4;
              var containsArg = sampleCell.ldf_1;
              tmp_12 = !(containsLower <= containsArg ? containsArg <= containsUpper : false);
            } else {
              var containsLower_0 = this.adg_1.ydd_1 * 1 / 4;
              var containsUpper_0 = this.adg_1.ydd_1 * 3 / 4;
              var containsArg_0 = sampleCell.kdf_1;
              tmp_12 = !(containsLower_0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false);
            }
            var needsRecentering = tmp_12;
            var tmp20_safe_receiver = this.adg_1.add_1;
            if (tmp20_safe_receiver == null)
              null;
            else {
              tmp20_safe_receiver.fcv(['' + sampleCell.kdf_1 + ' (at index ' + sampleCell.las() + ') !in (' + this.adg_1.ydd_1 * 1 / 4 + ')..(' + this.adg_1.ydd_1 * 3 / 4 + ')']);
            }
            var tmp21_safe_receiver = this.adg_1.add_1;
            if (tmp21_safe_receiver == null)
              null;
            else {
              tmp21_safe_receiver.fcv(['needsRecentering: ' + needsRecentering + ', atFalseEdge: ' + atScrollEdge + ', isMoving: ' + this.adg_1.rde_1.f2()]);
            }
            if (needsRecentering) {
              if (this.adg_1.zdc_1) {
                measure$requestOffset(this, this.adg_1, activeCells, 0.0, this.adg_1.ydd_1 * 0.5 - sampleCell.ldf_1);
              } else {
                measure$requestOffset(this, this.adg_1, activeCells, this.adg_1.ydd_1 * 0.5 - sampleCell.kdf_1, 0.0);
              }
            }
          }
        }
        var unusedCells = minus(activeCells, usedCells);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_1 = unusedCells.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_1 = _iterator__ex2g4s_1.o1();
          var tmp0_safe_receiver_6 = this.adg_1.add_1;
          if (tmp0_safe_receiver_6 == null)
            null;
          else {
            tmp0_safe_receiver_6.fcv(['Dismissing cell at ' + element_1.las()]);
          }
          if (rectOverlaps(element_1.kdf_1, element_1.ldf_1, element_1.mdf_1, element_1.ndf_1, this.vdf_1.jd0_1, this.vdf_1.kd0_1, this.vdf_1.ld0_1, this.vdf_1.md0_1)) {
            element_1.odg();
          } else {
            element_1.pdg();
          }
        }
        var v = this.adg_1.zdc_1 ? within.vd0(VOID, this.xdf_1) : within.vd0(this.xdf_1);
        this.wdf_1 = v;
        var tmp22_safe_receiver = this.adg_1.add_1;
        if (tmp22_safe_receiver == null)
          null;
        else {
          tmp22_safe_receiver.fcv(['Measure complete, result: ' + v.toString()]);
        }
        return v;
      }
      idb(layout, inProgress, within) {
        var tmp0_safe_receiver = this.adg_1.add_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['LAYOUT PROPER STARTED: ' + within.toString()]);
        }
        if (this.ydf_1)
          return Unit_instance;
        if (!this.zdf_1) {
          this.hdb(layout, inProgress, within);
        }
        if (this.adg_1.zdc_1) {
          inProgress.jdb(this.adg_1.edd_1, 0.0, this.xdf_1, within.td0_1, this.xdf_1 + 1);
        } else {
          inProgress.jdb(this.adg_1.edd_1, this.xdf_1, 0.0, this.xdf_1 + 1, within.ud0_1);
        }
        if (within.equals(Companion_getInstance_0().sd0_1))
          return Unit_instance;
        var tmp1_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(this.adg_1.mdj().xdg().qah());
        var tmp;
        if (tmp1_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var viewport = tmp;
        if (viewport.nd0() === 0.0 || viewport.od0() === 0.0)
          return Unit_instance;
        try {
          this.adg_1.zdd_1 = true;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = this.adg_1.wdd_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            layout$commitPosition(this.adg_1, inProgress, element);
          }
        }finally {
          this.adg_1.zdd_1 = false;
        }
        var tmp2_safe_receiver = this.adg_1.udd_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          $l$block_1: {
            if (this.adg_1.hde_1) {
              break $l$block_1;
            }
            if (this.adg_1.wdd_1.i1()) {
              break $l$block_1;
            }
            // Inline function 'kotlin.collections.sumOf' call
            var sum = 0;
            var _iterator__ex2g4s_0 = this.adg_1.wdd_1.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              var tmp_0 = sum;
              sum = tmp_0 + layout$_anonymous_$visibleRatio_9lqaa2(element_0, viewport);
            }
            var totalWeight = sum;
            if (totalWeight === 0.0) {
              break $l$block_1;
            }
            // Inline function 'kotlin.collections.sumOf' call
            var sum_0 = 0;
            var _iterator__ex2g4s_1 = this.adg_1.wdd_1.m1();
            while (_iterator__ex2g4s_1.n1()) {
              var element_1 = _iterator__ex2g4s_1.o1();
              var tmp_1 = sum_0;
              sum_0 = tmp_1 + layout$_anonymous_$visibleRatio_9lqaa2(element_1, viewport) * (element_1.las() + 0.5);
            }
            var averageIndex = sum_0 / totalWeight;
            var tmp_2;
            if (this.adg_1.zdc_1) {
              // Inline function 'kotlin.collections.sumOf' call
              var sum_1 = 0;
              var _iterator__ex2g4s_2 = this.adg_1.wdd_1.m1();
              while (_iterator__ex2g4s_2.n1()) {
                var element_2 = _iterator__ex2g4s_2.o1();
                var tmp_3 = sum_1;
                sum_1 = tmp_3 + layout$_anonymous_$visibleRatio_9lqaa2(element_2, viewport) * (element_2.ldf_1 + element_2.ndf_1) / 2;
              }
              tmp_2 = sum_1 / totalWeight;
            } else {
              // Inline function 'kotlin.collections.sumOf' call
              var sum_2 = 0;
              var _iterator__ex2g4s_3 = this.adg_1.wdd_1.m1();
              while (_iterator__ex2g4s_3.n1()) {
                var element_3 = _iterator__ex2g4s_3.o1();
                var tmp_4 = sum_2;
                sum_2 = tmp_4 + layout$_anonymous_$visibleRatio_9lqaa2(element_3, viewport) * (element_3.kdf_1 + element_3.mdf_1) / 2;
              }
              tmp_2 = sum_2;
            }
            var averagePosition = tmp_2;
            var estimatedElementPx = (this.adg_1.zdc_1 ? viewport.od0() : viewport.nd0()) / totalWeight;
            var totalElements = (tmp2_safe_receiver.yh().j2_1 - tmp2_safe_receiver.yh().i2_1 | 0) + 1 | 0;
            var estimatedTotalPx = estimatedElementPx * totalElements;
            var tmp0_safe_receiver_0 = this.adg_1.add_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.fcv(['totalWeight: ' + totalWeight]);
            }
            var tmp1_safe_receiver = this.adg_1.add_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.fcv(['averageIndex: ' + averageIndex]);
            }
            var tmp2_safe_receiver_0 = this.adg_1.add_1;
            if (tmp2_safe_receiver_0 == null)
              null;
            else {
              tmp2_safe_receiver_0.fcv(['averagePosition: ' + averagePosition]);
            }
            var tmp3_safe_receiver = this.adg_1.add_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.fcv(['estimatedElementPx: ' + estimatedElementPx]);
            }
            var tmp4_safe_receiver = this.adg_1.add_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.fcv(['totalElements: ' + totalElements]);
            }
            var tmp5_safe_receiver = this.adg_1.add_1;
            if (tmp5_safe_receiver == null)
              null;
            else {
              tmp5_safe_receiver.fcv(['estimatedTotalPx: ' + estimatedTotalPx]);
            }
            var tmp6_safe_receiver = this.adg_1.add_1;
            if (tmp6_safe_receiver == null)
              null;
            else {
              tmp6_safe_receiver.fcv(['min: ' + (averageIndex - totalWeight / 2) / totalElements]);
            }
            var tmp7_safe_receiver = this.adg_1.add_1;
            if (tmp7_safe_receiver == null)
              null;
            else {
              tmp7_safe_receiver.fcv(['max: ' + (averageIndex + totalWeight / 2) / totalElements]);
            }
            setFakeScrollByRatio(this.adg_1, (averageIndex - totalWeight / 2) / totalElements, (averageIndex + totalWeight / 2) / totalElements);
          }
        }
        var tmp3_safe_receiver_0 = this.udf_1;
        var tmp_5;
        if (tmp3_safe_receiver_0 == null) {
          tmp_5 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_1 = this.adg_1.add_1;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.fcv(['EXECUTING SCROLL JUMP ' + toString(ReactiveState__getOrNull_impl_1asnfp(this.adg_1.mdj().xdg().qah())) + ' = ' + tmp3_safe_receiver_0.toString()]);
          }
          this.adg_1.ide_1 = true;
          this.adg_1.mdj().ndj(tmp3_safe_receiver_0.af_1, tmp3_safe_receiver_0.bf_1);
          this.udf_1 = null;
          tmp_5 = Unit_instance;
        }
        if (tmp_5 == null) {
          // Inline function 'kotlin.run' call
          var tmp0 = this.adg_1.wdd_1;
          var tmp$ret$14;
          $l$block_3: {
            // Inline function 'kotlin.collections.minByOrNull' call
            var iterator = tmp0.m1();
            if (!iterator.n1()) {
              tmp$ret$14 = null;
              break $l$block_3;
            }
            var minElem = iterator.o1();
            if (!iterator.n1()) {
              tmp$ret$14 = minElem;
              break $l$block_3;
            }
            var it = minElem;
            var dx = it.pd0() - viewport.pd0();
            var dy = it.qd0() - viewport.qd0();
            var minValue = dx * dx + dy * dy;
            do {
              var e = iterator.o1();
              var dx_0 = e.pd0() - viewport.pd0();
              var dy_0 = e.qd0() - viewport.qd0();
              var v = dx_0 * dx_0 + dy_0 * dy_0;
              if (compareTo(minValue, v) > 0) {
                minElem = e;
                minValue = v;
              }
            }
             while (iterator.n1());
            tmp$ret$14 = minElem;
          }
          var tmp0_safe_receiver_2 = tmp$ret$14;
          var tmp1_elvis_lhs_0 = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.las();
          this.adg_1.jdd_1.mam(tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
        }
        var tmp0_0 = this.adg_1.wdd_1;
        var tmp$ret$19;
        $l$block_4: {
          // Inline function 'kotlin.collections.minOfOrNull' call
          var iterator_0 = tmp0_0.m1();
          if (!iterator_0.n1()) {
            tmp$ret$19 = null;
            break $l$block_4;
          }
          var minValue_0 = iterator_0.o1().las();
          while (iterator_0.n1()) {
            var v_0 = iterator_0.o1().las();
            if (compareTo(minValue_0, v_0) > 0) {
              minValue_0 = v_0;
            }
          }
          tmp$ret$19 = minValue_0;
        }
        var tmp5_elvis_lhs = tmp$ret$19;
        this.adg_1.kdd_1.mam(tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs);
        var tmp0_1 = this.adg_1.wdd_1;
        var tmp$ret$22;
        $l$block_5: {
          // Inline function 'kotlin.collections.maxOfOrNull' call
          var iterator_1 = tmp0_1.m1();
          if (!iterator_1.n1()) {
            tmp$ret$22 = null;
            break $l$block_5;
          }
          var maxValue = iterator_1.o1().las();
          while (iterator_1.n1()) {
            var v_1 = iterator_1.o1().las();
            if (compareTo(maxValue, v_1) < 0) {
              maxValue = v_1;
            }
          }
          tmp$ret$22 = maxValue;
        }
        var tmp6_elvis_lhs = tmp$ret$22;
        this.adg_1.mdd_1.mam(tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs);
        this.zdf_1 = false;
        var tmp7_safe_receiver_0 = this.adg_1.add_1;
        if (tmp7_safe_receiver_0 == null)
          null;
        else {
          tmp7_safe_receiver_0.fcv(['LAYOUT COMPLETE']);
        }
        var tmp8_safe_receiver = this.adg_1.add_1;
        if (tmp8_safe_receiver == null)
          null;
        else {
          tmp8_safe_receiver.abn(['statsLayouts: ' + this.adg_1.ade_1 + ', statsMeasures: ' + this.adg_1.bde_1 + ', statsCellMoves: ' + this.adg_1.cde_1 + ', statsCellCount: ' + _get_statsCellCount__kp2e3h(this.adg_1)]);
        }
      }
    }
    initMetadataForClass($);
    Recycler2$programmaticLayoutDelegate$1Class = $;
  }
  return Recycler2$programmaticLayoutDelegate$1Class;
}
var Recycler2Class;
function Recycler2() {
  if (Recycler2Class === VOID) {
    class $ {
      constructor(viewWriter, vertical, log) {
        vertical = vertical === VOID ? true : vertical;
        log = log === VOID ? null : log;
        this.zdc_1 = vertical;
        this.add_1 = log;
        this.idd_1 = true;
        this.jdd_1 = Signal().fak(0);
        this.kdd_1 = Signal().fak(0);
        var tmp = this;
        tmp.ldd_1 = withWrite(this.kdd_1, Recycler2$firstIndex$slambda_0(this));
        this.mdd_1 = Signal().fak(0);
        var tmp_0 = this;
        tmp_0.ndd_1 = withWrite(this.mdd_1, Recycler2$lastIndex$slambda_0(this));
        var tmp_1 = this;
        tmp_1.odd_1 = withWrite(this.jdd_1, Recycler2$centerIndex$slambda_0(this));
        this.pdd_1 = null;
        this.qdd_1 = false;
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(viewWriter.pc());
        var tmp0_elvis_lhs = viewWriter.cbb_1;
        var p = tmp0_elvis_lhs == null ? viewWriter : tmp0_elvis_lhs;
        viewWriter.ebb(p, view);
        view.eba(get_px(0));
        this.bdd_1 = view;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = view.bbb_1;
        var tmp_2 = view;
        tmp_2.bbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          _this__u8e3s4.eba(get_px(0));
          _this__u8e3s4.iba(true);
          return Unit_instance;
        };
        var tmp_3 = Companion_getInstance_3();
        // Inline function 'com.lightningkite.kiteui.views.direct.scrolling' call
        // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
        var vertical_0 = this.zdc_1;
        var horizontal = !this.zdc_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev_0 = view.bbb_1;
        var tmp_4 = view;
        tmp_4.bbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev_0;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          var $this$scrolling = new (ScrollingBehaviorImpl())(_this__u8e3s4, horizontal, vertical_0);
          this.cdd_1 = $this$scrolling;
          $this$scrolling.odj(false);
          return Unit_instance;
        };
        Companion_getInstance_3();
        var tmp$ret$6 = Companion_getInstance_3();
        var tmp_5 = view.ibb(tmp_3, tmp$ret$6);
        // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
        Companion_getInstance_2();
        var tmp$ret$7 = new (Recycler2$$inlined$with$1())(view);
        var tmp_6 = view.ibb(tmp_5, view.hbb(tmp$ret$7));
        // Inline function 'com.lightningkite.kiteui.views.direct.programmatic' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (ProgrammaticLayout())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(null);
        view_0.iba(true);
        this.ddd_1 = view_0;
        var tmp_7 = get_unpadded(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        this.edd_1 = view_1;
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_7, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp_6, view_0);
        if (this.zdc_1) {
          var tmp_8 = get_atEnd(view);
          var tmp0_width = get_rem(1);
          var tmp1_maxWidth = get_rem(1);
          view.ibb(tmp_8, sizeConstraints(view, VOID, tmp1_maxWidth, VOID, VOID, VOID, tmp0_width));
        } else {
          var tmp_9 = get_atBottom(view);
          var tmp2_height = get_rem(1);
          var tmp3_maxHeight = get_rem(1);
          view.ibb(tmp_9, sizeConstraints(view, VOID, VOID, VOID, tmp3_maxHeight, VOID, VOID, tmp2_height));
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.scrolling' call
        // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
        var vertical_1 = this.zdc_1;
        var horizontal_0 = !this.zdc_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev_1 = view.bbb_1;
        var tmp_10 = view;
        tmp_10.bbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev_1;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          var $this$scrolling = new (ScrollingBehaviorImpl())(_this__u8e3s4, horizontal_0, vertical_1);
          this.fdd_1 = $this$scrolling;
          $this$scrolling.cb9(!get_current(Companion_instance).equals(Platform_Web_getInstance()));
          return Unit_instance;
        };
        Companion_getInstance_3();
        var tmp_11 = Companion_getInstance_3();
        // Inline function 'com.lightningkite.kiteui.views.direct.programmatic' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (ProgrammaticLayout())(view.pc());
        var tmp0_elvis_lhs_2 = view.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.ebb(p_2, view_2);
        this.gdd_1 = view_2;
        view_2.cb9(!get_current(Companion_instance).equals(Platform_Web_getInstance()));
        // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
        Companion_getInstance_2();
        var tmp$ret$19 = new (Recycler2$$inlined$with$2())();
        var tmp_12 = view_2.ibb(view_2.hbb(tmp$ret$19), get_unpadded(view_2));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Frame())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.cb9(!get_current(Companion_instance).equals(Platform_Web_getInstance()));
        this.hdd_1 = view_3;
        view_3.eb7(0.0);
        view_2.fbb(p_3, view_3);
        view_2.jbb(tmp_12, view_3);
        view.fbb(p_2, view_2);
        view.jbb(tmp_11, view_2);
        viewWriter.fbb(p, view);
        this.rdd_1 = get_viewUnits(AppState_getInstance().mbi().f2().fbi_1) / 3.0;
        this.sdd_1 = new (SpecificElement())(0, Align_Start_getInstance());
        this.tdd_1 = new (RecyclerViewPlacerVerticalGrid())(1);
        this.udd_1 = Empty_instance;
        this.vdd_1 = Empty_instance_0;
        this.wdd_1 = ArrayList().w();
        this.xdd_1 = ArrayList().w();
        this.ydd_1 = 50000.0;
        this.zdd_1 = false;
        this.ade_1 = 0;
        this.bde_1 = 0;
        this.cde_1 = 0;
        this.dde_1 = null;
        this.ede_1 = false;
        this.fde_1 = 0.0;
        this.gde_1 = 0.01;
        this.hde_1 = false;
        this.ide_1 = false;
        this.jde_1 = false;
        this.kde_1 = 0.0;
        this.lde_1 = 0.0;
        this.mde_1 = 0.0;
        this.nde_1 = 0.0;
        this.ode_1 = 0.0;
        this.pde_1 = 0.0;
        var tmp_13 = this;
        tmp_13.qde_1 = new (Recycler2$fakeScrollLayoutDelegate$1())(this);
        this.rde_1 = Signal().fak(false);
        this.gdd_1.pdj(this.qde_1);
        if (get_current(Companion_instance).equals(Platform_Web_getInstance())) {
          var lastSize = {_v: Companion_getInstance_0().sd0_1};
          reactive(this.ddd_1, ($this$reactive) => {
            var fsv = $this$reactive.baj(this.wdg().xdg());
            var tmp;
            if (!lastSize._v.equals(fsv.p1())) {
              lastSize._v = fsv.p1();
              return Unit_instance;
            }
            var tmp_0;
            if (this.jde_1) {
              this.jde_1 = false;
              return Unit_instance;
            }
            var tmp0_elvis_lhs = this.udd_1;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            var data = tmp_1;
            var tmp_2;
            if ((data.yh().j2_1 - data.yh().i2_1 | 0) <= 0) {
              return Unit_instance;
            }
            var tmp_3;
            if (this.kde_1 === 0.0) {
              return Unit_instance;
            }
            if (this.zdc_1) {
              var topRatio = fsv.kd0_1 / this.kde_1;
              var bottomRatio = fsv.md0_1 / this.kde_1;
              var centerRatio = (topRatio + bottomRatio) / 2;
              var controlRatio = topRatio + (bottomRatio - topRatio) * centerRatio;
              var controlIndex = controlRatio * ((data.yh().j2_1 - data.yh().i2_1 | 0) + 1 | 0);
              if (this.pdd_1 == null)
                this.sdd_1 = new (FuzzyIndex())(controlIndex, centerRatio);
              else
                this.sdd_1 = new (SpecificElement())(roundToInt(controlIndex), ensureNotNull(this.pdd_1));
              var tmp1_safe_receiver = this.add_1;
              if (tmp1_safe_receiver == null)
                null;
              else {
                tmp1_safe_receiver.fcv(['anchor = ' + toString(this.sdd_1) + ' (web fake scroll)']);
              }
            } else {
              var topRatio_0 = fsv.jd0_1 / this.kde_1;
              var bottomRatio_0 = fsv.ld0_1 / this.kde_1;
              var centerRatio_0 = (topRatio_0 + bottomRatio_0) / 2;
              var controlRatio_0 = topRatio_0 + (bottomRatio_0 - topRatio_0) * centerRatio_0;
              var controlIndex_0 = controlRatio_0 * ((data.yh().j2_1 - data.yh().i2_1 | 0) + 1 | 0);
              if (this.pdd_1 == null)
                this.sdd_1 = new (FuzzyIndex())(controlIndex_0, centerRatio_0);
              else
                this.sdd_1 = new (SpecificElement())(roundToInt(controlIndex_0), ensureNotNull(this.pdd_1));
              var tmp2_safe_receiver = this.add_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                tmp2_safe_receiver.fcv(['anchor = ' + toString(this.sdd_1) + ' (web fake scroll)']);
              }
            }
            this.hde_1 = true;
            var tmp3_safe_receiver = this.add_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.fcv(['fakeScrollInControl = true']);
            }
            var tmp4_safe_receiver = this.add_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.fcv(['fakeScroll.viewport calls invalidateLayout()']);
            }
            this.ddd_1.ddj();
            return Unit_instance;
          });
        }
        var timeoutRemover = {_v: Recycler2$lambda};
        var tmp_14 = this.mdj().xdg();
        onRemove(this.ddd_1, tmp_14.tah(() => {
          this.rde_1.mam(true);
          timeoutRemover._v();
          timeoutRemover._v = afterTimeout(this, 100n, () => {
            this.rde_1.mam(false);
            this.ddd_1.ddj();
            return Unit_instance;
          });
          if (this.ide_1) {
            this.ide_1 = false;
          } else {
            this.hde_1 = false;
            var tmp0_safe_receiver = this.add_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.fcv(['fakeScrollInControl = false']);
            }
          }
          var tmp;
          if (!this.zdd_1) {
            var tmp1_safe_receiver = this.add_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.fcv(['scroll.viewport calls invalidateLayout()']);
            }
            this.ddd_1.ddj();
            tmp = Unit_instance;
          }
          return Unit_instance;
        }));
        this.sde_1 = Companion_getInstance_1().hd0_1;
        var tmp_15 = this;
        tmp_15.tde_1 = new (Recycler2$programmaticLayoutDelegate$1())(this);
        this.ddd_1.pdj(this.tde_1);
        this.ude_1 = 1;
      }
      ea2() {
        return this.bdd_1.ea2();
      }
      mdj() {
        var tmp = this.cdd_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('scroll');
        }
      }
      wdg() {
        var tmp = this.fdd_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('fakeScroll');
        }
      }
      aba() {
        return this.bdd_1;
      }
      zb8(value) {
        this.ddd_1.zb8(value);
      }
      qdj(value) {
        this.pdd_1 = value;
        this.mdj().rdj(this.zdc_1 ? to(null, value) : to(value, null));
      }
      sdj(value) {
        this.qdd_1 = value;
        this.mdj().sdj(value);
      }
      tdj(value) {
        this.tdd_1 = value;
        var tmp0_safe_receiver = this.add_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['placer set calls invalidateLayout()']);
        }
        this.ddd_1.ddj();
      }
      xde(value) {
        this.udd_1 = value;
        var tmp0_safe_receiver = this.add_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['data set calls invalidateLayout()']);
        }
        this.ddd_1.ddj();
      }
      vde(value) {
        this.vdd_1 = value;
        // Inline function 'kotlin.collections.forEach' call
        var progression = downTo(get_lastIndex(this.ddd_1.oba()), 1);
        var inductionVariable = progression.i2_1;
        var last = progression.j2_1;
        var step = progression.k2_1;
        if (step > 0 && inductionVariable <= last || (step < 0 && last <= inductionVariable))
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + step | 0;
            var it = element;
            this.ddd_1.xb9(it);
          }
           while (!(element === last));
        this.wdd_1 = ArrayList().w();
        this.xdd_1 = ArrayList().w();
        var tmp0_safe_receiver = this.add_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['rendererSet set calls invalidateLayout()']);
        }
        this.ddd_1.ddj();
      }
      udj(toIndex, align, animate) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = this.wdd_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.las() === toIndex) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_0 = this.mdj();
          var tmp_1;
          if (this.zdc_1) {
            tmp_1 = 0.0;
          } else {
            switch (align.b4_1) {
              case 0:
                tmp_1 = tmp0_safe_receiver.kdf_1 - this.nde_1;
                break;
              case 2:
                tmp_1 = tmp0_safe_receiver.mdf_1 - this.sde_1.nd0();
                break;
              default:
                tmp_1 = tmp0_safe_receiver.pd0() - this.sde_1.nd0() / 2;
                break;
            }
          }
          var tmp_2 = tmp_1;
          var tmp_3;
          if (!this.zdc_1) {
            tmp_3 = 0.0;
          } else {
            switch (align.b4_1) {
              case 0:
                tmp_3 = tmp0_safe_receiver.ldf_1 - this.mde_1;
                break;
              case 2:
                tmp_3 = tmp0_safe_receiver.ndf_1 - this.sde_1.od0();
                break;
              default:
                tmp_3 = tmp0_safe_receiver.qd0() - this.sde_1.od0() / 2;
                break;
            }
          }
          tmp_0.ldj(tmp_2, tmp_3, animate);
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var $this$run = this;
          var tmp_4;
          var tmp_5;
          if (animate) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp_5 = !$this$run.wdd_1.i1();
          } else {
            tmp_5 = false;
          }
          if (tmp_5) {
            // Inline function 'kotlin.collections.maxOf' call
            var iterator = $this$run.wdd_1.m1();
            if (!iterator.n1())
              throw NoSuchElementException().y1();
            var maxValue = iterator.o1().las();
            while (iterator.n1()) {
              var v = iterator.o1().las();
              if (compareTo(maxValue, v) < 0) {
                maxValue = v;
              }
            }
            var destinationAhead = toIndex > maxValue;
            if (destinationAhead) {
              $this$run.sdd_1 = new (SpecificElement())(toIndex, Align_End_getInstance());
            } else {
              $this$run.sdd_1 = new (SpecificElement())(toIndex, Align_Start_getInstance());
            }
            $this$run.ddd_1.ddj();
            tmp_4 = afterTimeout($this$run, 16n, () => {
              // Inline function 'kotlin.collections.find' call
              var tmp0 = $this$run.wdd_1;
              var tmp$ret$10;
              $l$block_0: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var _iterator__ex2g4s = tmp0.m1();
                while (_iterator__ex2g4s.n1()) {
                  var element = _iterator__ex2g4s.o1();
                  if (element.las() === toIndex) {
                    tmp$ret$10 = element;
                    break $l$block_0;
                  }
                }
                tmp$ret$10 = null;
              }
              var tmp0_safe_receiver = tmp$ret$10;
              var tmp;
              if (tmp0_safe_receiver == null) {
                tmp = null;
              } else {
                // Inline function 'kotlin.let' call
                var tmp_0 = $this$run.mdj();
                var tmp_1;
                if ($this$run.zdc_1) {
                  tmp_1 = 0.0;
                } else {
                  switch (align.b4_1) {
                    case 0:
                      tmp_1 = tmp0_safe_receiver.kdf_1 - $this$run.nde_1;
                      break;
                    case 2:
                      tmp_1 = tmp0_safe_receiver.mdf_1 - $this$run.sde_1.nd0();
                      break;
                    default:
                      tmp_1 = tmp0_safe_receiver.pd0() - $this$run.sde_1.nd0() / 2;
                      break;
                  }
                }
                var tmp_2 = tmp_1;
                var tmp_3;
                if (!$this$run.zdc_1) {
                  tmp_3 = 0.0;
                } else {
                  switch (align.b4_1) {
                    case 0:
                      tmp_3 = tmp0_safe_receiver.ldf_1 - $this$run.mde_1;
                      break;
                    case 2:
                      tmp_3 = tmp0_safe_receiver.ndf_1 - $this$run.sde_1.od0();
                      break;
                    default:
                      tmp_3 = tmp0_safe_receiver.qd0() - $this$run.sde_1.od0() / 2;
                      break;
                  }
                }
                tmp_0.ldj(tmp_2, tmp_3, animate);
                tmp = Unit_instance;
              }
              var tmp1_elvis_lhs = tmp;
              var tmp_4;
              if (tmp1_elvis_lhs == null) {
                // Inline function 'kotlin.run' call
                var $this$run_0 = $this$run;
                $this$run_0.sdd_1 = new (SpecificElement())(toIndex, align);
                $this$run_0.ddd_1.ddj();
                tmp_4 = Unit_instance;
              } else {
                tmp_4 = tmp1_elvis_lhs;
              }
              return Unit_instance;
            });
          } else {
            $this$run.sdd_1 = new (SpecificElement())(toIndex, align);
            $this$run.ddd_1.ddj();
            tmp_4 = Unit_instance;
          }
        }
      }
      gdj(toIndex, align, animate, $super) {
        animate = animate === VOID ? true : animate;
        var tmp;
        if ($super === VOID) {
          this.udj(toIndex, align, animate);
          tmp = Unit_instance;
        } else {
          tmp = $super.udj.call(this, toIndex, align, animate);
        }
        return tmp;
      }
      vdj() {
        return this.ndd_1;
      }
    }
    initMetadataForClass($, 'Recycler2', VOID, VOID, [CoroutineScope()]);
    Recycler2Class = $;
  }
  return Recycler2Class;
}
function rectOverlaps(l1, t1, r1, b1, l2, t2, r2, b2) {
  return l1 < r2 && r1 > l2 && t1 < b2 && b1 > t2;
}
function popOrNull(_this__u8e3s4, condition) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s = _this__u8e3s4.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      if (condition(item)) {
        tmp$ret$0 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$0 = -1;
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  return !(it === -1) ? _this__u8e3s4.z3(it) : null;
}
function estimateJumpAnchor(activeCells, vertical, viewport) {
  if (activeCells.i1())
    return null;
  var totalWeight = activeCells.p1();
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = activeCells.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp = sum;
    sum = tmp + element.las() | 0;
  }
  var averageIndex = sum / totalWeight | 0;
  var tmp_0;
  if (vertical) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_0 = activeCells.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      var tmp_1 = sum_0;
      sum_0 = tmp_1 + (element_0.sdg() + element_0.udg()) / 2;
    }
    tmp_0 = sum_0 / totalWeight;
  } else {
    // Inline function 'kotlin.collections.sumOf' call
    var sum_1 = 0;
    var _iterator__ex2g4s_1 = activeCells.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_1 = _iterator__ex2g4s_1.o1();
      var tmp_2 = sum_1;
      sum_1 = tmp_2 + (element_1.rdg() + element_1.tdg()) / 2;
    }
    tmp_0 = sum_1;
  }
  var averagePosition = tmp_0;
  // Inline function 'kotlin.collections.minOf' call
  var iterator = activeCells.m1();
  if (!iterator.n1())
    throw NoSuchElementException().y1();
  var it = iterator.o1();
  var minValue = vertical ? it.sdg() : it.rdg();
  while (iterator.n1()) {
    var it_0 = iterator.o1();
    var v = vertical ? it_0.sdg() : it_0.rdg();
    // Inline function 'kotlin.comparisons.minOf' call
    var a = minValue;
    minValue = Math.min(a, v);
  }
  var min = minValue;
  // Inline function 'kotlin.collections.maxOf' call
  var iterator_0 = activeCells.m1();
  if (!iterator_0.n1())
    throw NoSuchElementException().y1();
  var it_1 = iterator_0.o1();
  var maxValue = vertical ? it_1.udg() : it_1.tdg();
  while (iterator_0.n1()) {
    var it_2 = iterator_0.o1();
    var v_0 = vertical ? it_2.udg() : it_2.tdg();
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = maxValue;
    maxValue = Math.max(a_0, v_0);
  }
  var max = maxValue;
  var estimatedElementPx = (max - min) / totalWeight;
  var diff = (vertical ? viewport.qd0() : viewport.pd0()) - averagePosition;
  return new (FuzzyIndex())(averageIndex + diff / estimatedElementPx, 0.5);
}
//region block: exports
export {
  Recycler2 as Recycler21f097l2zl8cft,
  estimateJumpAnchor as estimateJumpAnchor3fhl00o07marf,
};
//endregion

//# sourceMappingURL=Recycler2.mjs.map
